import React from "react";
import { useCityList } from "@/component/GoldSilver/CITY_CONSTANT";
import { getCitiesForLocation } from "@/component/GoldSilver/cityList";

const GOLD_COLUMNS = [
  { key: "carat24", label: "24 कैरेट" },
  { key: "carat22", label: "22 कैरेट" },
  { key: "carat18", label: "18 कैरेट" },
];

const SILVER_COLUMNS = [
  { key: "oneGram", label: "1 ग्राम" },
  { key: "tenGram", label: "10 ग्राम" },
  { key: "hundredGram", label: "100 ग्राम" },
  { key: "oneKg", label: "1000 ग्राम" },
];
function normalizeCity(str = "") {
  return str?.toLowerCase()?.replace(/[-\s]+/g, " ")?.trim();
}
function getCityHn(cities, cityName) {
  const match = cities.find((c) => normalizeCity(c.city) === normalizeCity(cityName));
  return match?.city_hn || cityName;
}


function extractHex(cls, fallback) {
  if (!cls) return fallback;
  const match = cls.match(/#([0-9a-fA-F]{3,8})/);
  if (!match) return fallback;
  let hex = match[1];
  if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
  return `#${hex.slice(0, 6)}`;
}

function stickyFillStyle(tintColor, extraShadow, borderColor) {
  const shadows = [extraShadow, `inset 0 0 0 0 ${borderColor}`, `inset 0 0 0 9999px ${tintColor}`].filter(Boolean);
  return {
    backgroundColor: "#ffffff",
    boxShadow: shadows.join(", "),
    transform: "translateZ(0)",
  };
}

export const CityCompareTable = ({ data, city, type = "gold", colors = {} }) => {
  const allCities = useCityList();
  const cities = city ? getCitiesForLocation(city) : allCities;
  const isGold = type === "gold";
  const columns = isGold ? GOLD_COLUMNS : SILVER_COLUMNS;

  const filteredData = (data || []).filter((row) =>
    cities.some((c) => normalizeCity(c.city) === normalizeCity(row.city))
  );

  if (!filteredData || filteredData.length === 0) {
    return (
      <div className="px-4 py-4 text-center text-sm text-gray-400">
        कोई डेटा उपलब्ध नहीं है
      </div>
    );
  }

  const sortedData = [...filteredData].sort((a, b) => {
    const aIsCurrent = normalizeCity(a.city) === normalizeCity(city);
    const bIsCurrent = normalizeCity(b.city) === normalizeCity(city);
    if (aIsCurrent) return -1;
    if (bIsCurrent) return 1;
    return 0;
  });

  return (
    <div className="overflow-y-auto h-[408px]  ">
      <table className="min-w-full text-sm border-b border-spacing-0">
        <thead
          className={`sticky top-0 z-10 ${colors.lightBg || "bg-[#fafafa]"}`}
        >
          <tr>
            <th
              className="sticky top-0 left-0 z-30 px-4 right-0 py-2 text-xs md:text-sm font-semibold whitespace-nowrap text-left will-change-transform"
              style={{ ...stickyFillStyle(extractHex(colors.lightBgL, "#fafafa"), null, extractHex(colors.border, "#e5e7eb")), width: "140px" }}
            >
              शहर
            </th>

            {columns.map((col) => (
              <th
                key={col.key}
                className={`px-2 top-0 md:px-4 py-3 text-xs md:text-sm font-semibold border-b ${colors.border || "border-gray-200"} whitespace-nowrap text-center`}
                style={{ ...stickyFillStyle(extractHex(colors.lightBgL, "#fafafa"), null, extractHex(colors.border, "#e5e7eb")), width: "140px" }}
              >

                {col.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {sortedData.map((row, index) => {
            const isCurrent = normalizeCity(row.city) === normalizeCity(city);

            return (
              <tr
                key={index}
                className={`border-b ${colors.border || "border-gray-200"} last:border-none hover:bg-gray-50 ${isCurrent
                  ? type === "gold"
                    ? "bg-[#FFFDF5]"
                    : "bg-[#F8F9FB99]"
                  : ""
                  }`}
              >
                <td className="px-2 md:px-4 py-3 whitespace-nowrap text-xs md:text-sm text-left font-semibold">
                  <span className="inline-flex items-center gap-2">
                    {isCurrent && (
                      <span
                        className={`rounded-full bg-orange-100 ${colors.gradient} text-[10px] font-bold px-2 md:px-4 py-0.5`}
                      >
                        यहाँ
                      </span>
                    )}
                    {isCurrent ? getCityHn(cities, row.city) : <a href={`/${type}-rates/${row.city?.toLowerCase()}-${type}-price-today`} className="cursor-pointer  hover:underline hover:text-primary " >

                      {getCityHn(cities, row.city)}
                    </a>}
                  </span>
                </td>

                {columns.map((col) => (
                  <td
                    key={col.key}
                    className="px-2 md:px-4 py-3 whitespace-nowrap text-xs md:text-sm text-center"
                  >
                    {row[col.key] ?? "-"}

                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
